import { render, staticRenderFns } from "./SettingsExportCalendar.vue?vue&type=template&id=532534cb&"
import script from "./SettingsExportCalendar.vue?vue&type=script&lang=js&"
export * from "./SettingsExportCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SettingsExportCalendar.vue?vue&type=style&index=0&id=532534cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports